"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.StateEvent = void 0;
const stateChanged = 'stateChanged';
const error = 'error';
exports.StateEvent = { Error: error, StateChanged: stateChanged };
var State;
(function (State) {
    State["Opened"] = "Opened";
    State["Closed"] = "Closed";
    State["Pending"] = "Pending";
})(State || (exports.State = State = {}));
